import { DataSource, CollectionViewer } from "@angular/cdk/collections";
import { BehaviorSubject, Subscription, Observable } from "rxjs";
import { Config } from "src/infrastructure/config";
import { ProductCollectionItem } from "src/models/DTO/products/productCollectionItem";
import { ImagesService } from "src/services/request/images/images.service";
import { ProductsService } from "src/services/request/products/products.service";
import { RatingsService } from "src/services/request/ratings/ratings.service";

export class SellerProductDataSource extends DataSource<ProductCollectionItem | undefined> {
    private _length = Config.defaultItemsPerPage;
    private _lastPage: number = -1;
    private _partnerUUID: string;
    private _query: string;
    private _pageSize = Config.defaultItemsPerPage;
    private _cachedData = Array.from<ProductCollectionItem>({length: this._length});;
    private _fetchedPages = new Set<number>();
    private readonly _dataStream = new BehaviorSubject<(ProductCollectionItem | undefined)[]>(this._cachedData);
    private readonly _subscription = new Subscription();
    private virtualScroll?: any;

    constructor(
      private productsService: ProductsService,
      private imagesService: ImagesService,
      private ratingsService: RatingsService,
      lastPage: number,
      partnerUUID: string,
      query: string) {
      super();
      this._lastPage = lastPage;
      this._partnerUUID = partnerUUID;
      this._query = query;
    }

    connect(collectionViewer: CollectionViewer): Observable<(ProductCollectionItem | undefined)[]> {
      this.virtualScroll = collectionViewer;
      this._subscription.add(
        collectionViewer.viewChange.subscribe(range => {
          const startPage = this._getPageForIndex(range.start);
          const endPage = this._getPageForIndex(range.end - 1);
          for (let i = startPage; i <= endPage; i++) {
            this._fetchPage(i);
          }
        }),
      );
      return this._dataStream;
    }
  
    disconnect(): void {
      this._subscription.unsubscribe();
    }
  
    private _getPageForIndex(index: number): number {
      return Math.floor(index / this._pageSize);
    }
  
    private _fetchPage(pageToLoad: number) {
      const page = pageToLoad;
      const pageFromServer = pageToLoad + 1; 
      if (this._fetchedPages.has(page)) {
        return;
      }
      if (this._lastPage < page) {
        return;
      }
      this._fetchedPages.add(page);

      this.productsService.getAllPortionOfProductsPerPartner(this._pageSize, pageFromServer, this._partnerUUID, this._query).subscribe(products => {
        // Cannot get image because of auth
        products.data.forEach(product => {
          product.imageURL = '';
          this.imagesService.getImagesForProduct("PRODUCT", product.uuid).subscribe(images => {
            product.imageURL = images.data[0].original.url
          })
          product.ratings = { data: []}
          this.getRatingsForProduct(product);
        })
        this._cachedData.splice(
          page * this._pageSize,
          this._pageSize,
          ...products.data
        );
        this._dataStream.next(this._cachedData);
        this.virtualScroll!._viewport.checkViewportSize()
      })
    }

    
    private getRatingsForProduct(product: ProductCollectionItem) {
      this.ratingsService.getRatingsPerProduct(product.uuid).subscribe(ratings => {
          product.ratings = ratings;
          this.getRatingsAvg(product)
      })
    }
  
    private getRatingsAvg(product: ProductCollectionItem) {
      let ratingsScore = 0;
      const ratingsCount = product.ratings?.data.length || 0;
      product.ratings?.data.forEach(rating => {
        ratingsScore += rating.rating
      })
      product.ratingAvgValue = ratingsScore / ratingsCount;
    }
  }